import "babel-polyfill";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { SkipToContent } from "./components/SkipToContent";
import { unregister as unregisterServiceWorker } from "./registerServiceWorker";

import "./css/default.scss";
import "./css/tablet.scss";
import "./css/web.scss";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <>
    <SkipToContent contentId="MainNavigation" skipText="Skip to main navigation" />
    <SkipToContent />
    <SkipToContent contentId="FooterContent" skipText="Skip to footer" />
    <App />
  </>,
);

unregisterServiceWorker();
